import flatten from 'flatten-object';
import { b64EncodeUnicode } from './dev-tools';

export function getSize() {
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  const height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

  return { width, height };
}

export function getZoomScaledSize(width, height) {
  let scaledWidth, scaledHeight, maxHeight, maxWidth;

  const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  const h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  maxHeight = Math.floor(0.8 * h);
  maxWidth = Math.floor(0.7 * w);

  scaledHeight = maxHeight;
  scaledWidth = Math.floor((scaledHeight / height) * width);

  if (scaledWidth > maxWidth) {
    scaledWidth = maxWidth;
    scaledHeight = Math.floor((scaledWidth / width) * height);
  }

  return {scaledWidth, scaledHeight};
}

/**
 * Transform object to basic string hash to use it as key
 * @param {Object} objectToHash
 */
export const generateHashFromVars = (objectToHash) => {
  return unescape(b64EncodeUnicode(JSON.stringify(flatten(objectToHash))));
};

/**
 * Extract deep values from array with string, dot separated, key
 * @param {Object} object
 * @param {String} key
 * @example let array = {'primary': { 'secondary': 'test'}}
 *          let key = 'primary.secondary'
 *          return 'test'
 * @return {String}
 */
export const objectExtractValue = (object, key) => {
  let returned = object;
  const decomposedKey = key.split('.');
  decomposedKey.forEach(deepKey => {
    returned = returned && returned[deepKey];
  });
  return returned;
};
